const QUICK_VIEW_ICON = '.rebuy-quick-view__search-input .rebuy-icon-wrapper--inline'
const QUICK_VIEW_INPUT = '.rebuy-quick-view__search-input'

const submitSearch = (input) => {
  if (!input || !input.value.trim()) return

  input.focus()
  input.dispatchEvent(new Event('input', { bubbles: true }))
  input.dispatchEvent(
    new KeyboardEvent('keydown', {
      key: 'Enter',
      code: 'Enter',
      keyCode: 13,
      which: 13,
      bubbles: true,
      cancelable: true,
    })
  )
}

document.addEventListener('click', (event) => {
  const icon = event.target.closest(QUICK_VIEW_ICON)

  if (!icon) return

  event.preventDefault()
  event.stopPropagation()

  submitSearch(icon.closest(QUICK_VIEW_INPUT).querySelector('input'))
})
